import React, { useEffect, useRef, useState, ElementType } from "react";
import type { FC, ReactNode } from "react";
import ReactMarkdown from "react-markdown";
import startupDilligenceImage from "../../ai-agent/landing/_assets/startup-dilligence.png";
import customerReportImage from "../_assets/customer-report-image.jpg";
import customerIcon from "../_assets/customer-icon.svg";
import userIcon from "../_assets/user-icon.svg";
import coverImage from "./_assets/Minimalist-Business-Marketing-Annual-Report-Cover.jpg";
import MainReportPage from "./_assets/MainReportImage-360.svg";
import InvestmentFront from "./_assets/investment-front.svg";
import ReportFront from "./_assets/report-front.svg";

import AuditParameter from "./_assets/Audit-Parameters.svg";
import CustomizeTone from "./_assets/Customize-tone.svg";
import DownloadOption from "./_assets/Download.svg";
import img1 from "./_assets/img-1.png";
import img2 from "./_assets/img-2.png";
import jsCookie from "js-cookie";
import template1 from "./_assets/template-1.jpg";
import template2 from "./_assets/template-2.jpg";
import template3 from "./_assets/template-3.jpg";
import template4 from "./_assets/template-4.jpg";
import template5 from "./_assets/template-5.jpg";
import { useAppDispatch } from "src/hooks/redux";
import { ChevronDown, ChevronUp, Download, X } from "lucide-react";
import {
  executePipelineAction,
  getInteractiveReportAction,
  getPipelineStatus,
  getReportTitle,
  getSourceInsights,
  interactiveReportInput,
} from "./action";
import DotLoader from "src/components/reusable/dot-loader";
import QuerySlideshow from "./QueryResult";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeExternalLinks from "rehype-external-links";
import UsedSourcesAccordion from "./SourceAcc";

import { Pencil, History, Presentation, Flag, File, Loader2, CheckCircle, RefreshCcw } from "lucide-react";
import ToolTip from "src/components/reusable/tool-tip";
import { Modal } from "src/components/reusable/modal/Modal";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useLocation, useSearchParams } from "react-router-dom";
import { title } from "process";
import ExecutiveSummary from "./ExecutiveSummary";
import { downloadReportPdf, downloadReportDocx } from "./downloadReport";


type SummaryType = {
  section: string;
  subsection: string;
  summary: string;
  stat_validation?: {
    valid?: string;
    confidence?: string;
    error_margin?: string;
    weighted_score?: string;
    comment?: string;
  };
  retrieved_sources?: {
    url: string;
    used: boolean;
    score: number;
    reason: string;
    query: string;
  }[];
};

type VisualType = {
  section: string;
  subsection: string;
  type: "chart" | "image";
  file?: string;
  image_url?: string;
};

interface NavItemProps {
  number: number;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

interface ContentCardProps {
  title: string;
  children: ReactNode;
}

const icons = [
  { name: "Regenerate Report", Component: RefreshCcw },
  //  { name: "Edit", Component: Pencil },
  //  { name: "History", Component: History },
  //  { name: "Presentation", Component: Presentation },
  //  { name: "Report", Component: Flag },
  { name: "Download", Component: Download },
  { name: "Download Doc", Component: Download }


];

const IconButton = ({ Icon, label, onClick }: { Icon: ElementType; label: string; onClick?: () => void }) => (
  <button
    type="button"
    className="p-1 bg-violet-100/50 hover:bg-violet-200/70 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-opacity-50 rounded transition-colors duration-200"
    aria-label={label}
    onClick={onClick}
  >
    <Icon className="w-2 h-2 text-violet-800" />
  </button>
);

// --- Placeholder Content Components ---
const ExploreReportContent: React.FC<{ title: string, desc: string, fetchingTitle: boolean, agent: string }> = ({ title, desc, fetchingTitle, agent }) => {

  const frontPagemapper: Record<string, any> = {
    "customer-360-agent": {
      image: MainReportPage,
      color: "text-white",
      top: "top-[55%]"
    },
    "marketing-agent": {
      image: MainReportPage,
      color: "text-white",
      top: "top-[55%]"
    },
    "investment-diligence-agent": {
      image: InvestmentFront,
      color: "text-black",
      top: "top-[65%]"
    },
    "report-anything-agent": {
      image: ReportFront,
      color: "text-black",
      top: "top-[65%]"
    },
    "": {
      image: MainReportPage,
      color: "text-white",
      top: "top-[55%]"
    },
  }

  return (
    <ContentCard title="">
      <div className="image-banner relative">
        <img src={frontPagemapper[agent].image} alt="" className="w-full" />
        <div className={`w-full absolute ${frontPagemapper[agent].top} left-1/2 text-center -translate-x-1/2 -translate-y-1/2 ${frontPagemapper[agent].color}`}>
          {fetchingTitle ? null :
            <>
              <div className="text-3xl mb-2 font-semibold font-eb-garamond mt-7">
                {title}
              </div>
              <div className="text-4xl mb-2 font-semibold font-eb-garamond">
                {desc}
              </div>

            </>
          }
        </div>
        <div className={`font-eb-garamond font-semibold text-2xl md:min-w-[800px] absolute bottom-[10%] left-1/2 ${frontPagemapper[agent].color} text-center -translate-x-1/2`}>
          {new Date().toLocaleString("en-US", { month: "long", year: "numeric" })}
        </div>
      </div>
    </ContentCard>
  )
}

const AuditParametersContent: FC = () => {
  const [highlightLowConfidence, setHighlightLowConfidence] = useState(true);

  const statisticalParamsHeaders = ['Section', 'Parameter', 'CI', 'Source', 'Method'];
  const statisticalParamsData = [
    ['Segmentation', 'Propensity - to - convert', '92%', 'CRM Logs', 'Logistic Regression'],
    ['Engagement', 'Cohort Stickiness Index', '88%', 'App Usage', 'Cohort Analysis'],
    ['Segmentation', 'Segmentation', '81%', 'Purchase History', 'Weighted Scoring'],
  ];

  const modelSummariesHeaders = ['Model Name', 'Type', 'Performance', 'Training Size', 'Source'];
  const modelSummariesData = [
    ['Segmentation', 'Propensity - to - convert', '92%', 'CRM Logs', 'Logistic Regression'],
    ['Engagement', 'Cohort Stickiness Index', '88%', 'App Usage', 'Cohort Analysis'],
  ];

  return (
    <ContentCard title="">

      <div className="w-full">

        {/* Statistical Parameters Section */}
        <section>
          <h2 className="text-base font-semibold text-secondary-800 mb-2">Statistical Parameters Used</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse rounded-md">
              <thead>
                <tr>
                  {statisticalParamsHeaders.map((header) => (
                    <th key={header} className="py-[12px] px-2 bg-[#F2F2F2] text-sm font-semibold text-secondary-800 border-b">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {statisticalParamsData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                      <td key={cellIndex} className="py-[12px] px-2 text-sm text-gray-700 border-b">
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Validation Chain Section */}
        <section className="mt-2">
          <h2 className="text-base font-semibold text-secondary-800 mb-2">Validation Chain Per Insight</h2>
          <div className="bg-[#F7F2FF] py-2 px-3 rounded-lg">
            <p className="text-gray-700 text-sm">
              Churn Risk <span className="font-mono mx-2 text-purple-600">→</span>
              Failed Logins (Direct) <span className="font-mono mx-2 text-purple-600">→</span>
              Industry Benchmarks (Indirect)
            </p>

            <div className="mt-1">
              <h3 className="text-base font-semibold text-secondary-800 mb-1">Color Legend</h3>
              <div className="flex items-center space-x-3 text-sm">
                <div className="flex items-center"><span className="w-2 h-2 bg-[#4887D6] rounded-full mr-1"></span>High Credibility</div>
                <div className="flex items-center"><span className="w-2 h-2 bg-[#F9D558] rounded-full mr-1"></span>Moderate</div>
                <div className="flex items-center"><span className="w-2 h-2 bg-[#F04A5F] rounded-full mr-1"></span>Low</div>
              </div>
            </div>
          </div>
        </section>

        {/* Model Summaries Section */}
        <section className="mt-2">
          <h2 className="text-base font-semibold text-secondary-800 mb-2">Model Summaries</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse rounded-md">
              <thead>
                <tr>
                  {modelSummariesHeaders.map((header) => (
                    <th key={header} className="y-[12px] px-2 bg-[#F2F2F2] text-sm font-semibold text-secondary-800 border-b">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {modelSummariesData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                      <td key={cellIndex} className="py-[12px] px-2 text-sm text-gray-700 border-b">
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Glossary Section */}
        <section className="mt-2">
          <h2 className="text-base font-semibold text-secondary-800 mb-2">Glossary</h2>
          <div className="bg-[#F7F2FF] px-3 py-2  rounded-lg border border-purple-100">
            <div className="mb-2">
              <h4 className="font-semibold text-[#373D3F]">Propensity-to-Convert</h4>
              <p className="text-sm text-[#373D3F]">The likelihood a user will take a key action based on historical patterns.</p>
            </div>
            <div className="mb-2">
              <h4 className="font-semibold text-[#373D3F]">RFV Composite</h4>
              <p className="text-sm text-[#373D3F]">A combined score using Recency, Frequency, and Value for behavioral segmentation.</p>
            </div>
            <div className="mb-2">
              <h4 className="font-semibold text-[#373D3F]">Confidence Interval (CI)</h4>
              <p className="text-sm text-[#373D3F]">The probability range within which the true value is expected to lie.</p>
            </div>
          </div>
        </section>

        {/* Toggle Switch */}
        <div className="flex items-center mt-2">
          <span className="text-sm font-medium text-secondary-800 mr-2">Highlight Low-Confidence Metrics:</span>
          <button
            onClick={() => setHighlightLowConfidence(!highlightLowConfidence)}
            className={`relative inline-flex items-center h-3 rounded-full w-6 transition-colors duration-300 focus:outline-none ${highlightLowConfidence ? 'bg-red-500' : 'bg-gray-300'
              }`}
          >
            <span
              className={`inline-block w-2 h-2 transform bg-white rounded-full transition-transform duration-300 ${highlightLowConfidence ? 'translate-x-3' : 'translate-x-1'
                }`}
            />
          </button>
        </div>
      </div>

    </ContentCard>
  );
};

const CustomizeLayoutContent: FC = () => (
  <ContentCard title="">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-1 md:gap-2">
      <div className="rounded-lg bg-[#FFF7ED] flex flex-col">
        <div className="rounded-t-lg px-1 pt-1 flex-1 overflow-hidden">
          <img src={template1} alt="" className="block mx-auto max-w-full h-full object-cover" />
        </div>
        <div className="text-lg text-black py-2 px-3 flex-0">Clean Executive</div>
      </div>

      <div className="rounded-lg bg-[#FFF7ED] md:row-span-2 flex flex-col">
        <div className="rounded-t-lg px-1 pt-1 flex-1">
          <img
            src={template2}
            alt=""
            className="block mx-auto max-w-full h-full object-cover object-center"
          />
        </div>
        <div className="text-lg text-black py-2 px-3 flex-0">Custom Saved Style</div>
      </div>

      <div className="rounded-lg bg-[#FFF7ED] flex flex-col">
        <div className="rounded-t-lg px-1 pt-1 flex-1">
          <img src={template3} alt="" className="block mx-auto max-w-full h-full object-cover" />
        </div>
        <div className="text-lg text-black py-2 px-3 flex-0">Modern Gradient</div>
      </div>

      <div className="rounded-lg bg-[#FFF7ED] flex flex-col">
        <div className="rounded-t-lg px-1 pt-1 flex-1">
          <img src={template4} alt="" className="block mx-auto max-w-full h-full object-cover" />
        </div>
        <div className="text-lg text-black py-2 px-3 flex-0">Card Format</div>
      </div>

      <div className="rounded-lg bg-[#FFF7ED] flex flex-col">
        <div className="rounded-t-lg px-1 pt-1 flex-1">
          <img src={template5} alt="" className="block mx-auto max-w-full h-full object-cover" />
        </div>
        <div className="text-lg text-black py-2 px-3 flex-0">Dark Theme</div>
      </div>
    </div>
  </ContentCard>
);

const CustomizeToneContent: FC = () => {
  const [selectedToneOptions, setSelectedToneOptions] = useState("Executive, Concise and directional");
  const [selectedToneLevel, setSelectedToneLevel] = useState("Executive, Concise and directional");
  const [selectedVocabularySetting, setSelectedVocabularySetting] = useState("Simple");
  const [selectedPronounUsage, setSelectedPronounUsage] = useState("First-person plural (We recommend)");
  const [selectedCallouts, setSelectedCallouts] = useState(["Strategy Tip", "Data Insight", "Risk Alert"]);
  return (
    <ContentCard title="">
      {/* <p className="text-secondary-800">
            Modify the tone and voice of the report's narrative. Options could range from formal and
            professional to a more casual and approachable style.
        </p> 
    <div className="image-banner relative">
      <img src={CustomizeTone} alt="" className="" />
    </div>
    */}
      <div className="mb-3">
        <label className="block font-semibold mb-1">Tone Options</label>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
          {['Executive, Concise and directional', 'Analytical, Data-first, neutral tone', 'Conversational, Friendly, human-readable', 'Persuasive, Action-forward, impact-driven', 'Investor-Focused, Highlights value, risk, and return', 'Cautious, Balanced, risk-aware framing'].map((tone) => (
            <label key={tone} className="flex items-center gap-1 cursor-pointer">
              <input
                type="radio"
                name="tone"
                value={tone}
                checked={selectedToneOptions === tone}
                onChange={() => setSelectedToneOptions(tone)}
                className="accent-primary-900"
              />
              <span className="text-sm">{tone}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="mb-3">
        <label className="block font-semibold mb-1">Tone Application Level</label>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-1">
          {['Entire Report', 'Specific Sections', 'Individual Paragraphs'].map((level) => (
            <label key={level} className="flex items-center gap-1 cursor-pointer">
              <input
                type="radio"
                name="level"
                value={level}
                checked={selectedToneLevel === level}
                onChange={() => setSelectedToneLevel(level)}
                className="accent-primary-900"
              />
              <span className="text-sm">{level}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="mb-3">
        <label className="block font-semibold mb-1">Advanced Language Settings <br />Vocabulary Setting:</label>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-1">
          {['Simple', 'Technical', 'Industry-specific'].map((vocab) => (
            <label key={vocab} className="flex items-center gap-1 cursor-pointer">
              <input
                type="radio"
                name="vocab"
                value={vocab}
                checked={selectedVocabularySetting === vocab}
                onChange={() => setSelectedVocabularySetting(vocab)}
                className="accent-primary-900"
              />
              <span className="text-sm">{vocab}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="mb-3">
        <label className="block font-semibold mb-1">Pronoun Usage:</label>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
          {['First-person plural (We recommend)', 'Passive voice', 'Objective/Neutral'].map((pronoun) => (
            <label key={pronoun} className="flex items-center gap-1 cursor-pointer">
              <input
                type="radio"
                name="pronoun"
                value={pronoun}
                checked={selectedPronounUsage === pronoun}
                onChange={() => setSelectedPronounUsage(pronoun)}
                className="accent-primary-900"
              />
              <span className="text-sm">{pronoun}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="mb-3">
        <label className="block font-semibold mb-1">Add Callouts:</label>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
          {['Strategy Tip', 'Data Insight', 'Risk Alert'].map((callout) => (
            <label key={callout} className="flex items-center gap-1 cursor-pointer">
              <input
                type="checkbox"
                name="callout"
                value={callout}
                checked={selectedCallouts.includes(callout)}
                onChange={() => setSelectedCallouts(selectedCallouts.includes(callout) ? selectedCallouts.filter((c) => c !== callout) : [...selectedCallouts, callout])}
                className="accent-primary-900"
              />
              <span className="text-sm">{callout}</span>
            </label>
          ))}
        </div>
      </div>
    </ContentCard>
  );
};

interface DownloadOptionsContentProps {
  updatePreviewPage: any
}

const DownloadOptionsContent: React.FC<DownloadOptionsContentProps> = (props) => {


  const [selectedExportFormats, setSelectedExportFormats] = useState("PDF");
  const [selectedAppendixControls, setSelectedAppendixControls] = useState(["Source Ledger", "Validation Chain Graphs", "Statistical Parameter Tables", "Glossary of Metrics", "Model Documentation"]);
  const [selectedCallouts, setSelectedCallouts] = useState(["Source Ledger", "Validation Chain Graphs", "Statistical Parameter Tables", "Glossary of Metrics", "Model Documentation"]);
  const [selectedDownloadModes, setSelectedDownloadModes] = useState("Audit Mode \n Full detail, confidence intervals, sources, glossary");
  const [selectedWhiteLabelSettings, setSelectedWhiteLabelSettings] = useState(["Hide all Generated by Perceive Now", "Replace with partner or client branding", "Remove watermark"]);
  const [selectedToneApplicationLevel, setSelectedToneApplicationLevel] = useState("Entire Report");
  return (
    <ContentCard title="">
      {/*
    <div className="image-banner relative">
      <img src={DownloadOption} alt="" className="" />
    </div>
     <p className="text-secondary-800">
            Choose your preferred format for downloading the report. Common options include PDF, CSV, and
            PNG.
        </p> */}
      <div className="mb-3">
        <label className="block font-semibold mb-1">Download</label>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
          {['Main Report', 'Executive Summary'].map((callout) => (
            <label key={callout} className="flex items-center gap-1 cursor-pointer">
              <input
                type="checkbox"
                name="callout"
                value={callout}
                checked={selectedCallouts.includes(callout)}
                onChange={() => setSelectedCallouts(selectedCallouts.includes(callout) ? selectedCallouts.filter((c) => c !== callout) : [...selectedCallouts, callout])}
                className="accent-primary-900"
              />
              <span className="text-sm">{callout}{"    "}<span className="text-sm underline" role="button" onClick={() => props.updatePreviewPage({
                page: "report",
                type: callout === "Main Report" ? "full" : "summary"
              })}>(Preview)</span></span>
            </label>
          ))}
        </div>
      </div>

      <div className="mb-3">
        <label className="block font-semibold mb-1">Export Formats</label>
        <div className="flex flex-wrap gap-1 md:gap-3 lg:gap-4">
          {['PDF', 'PPTX (Deck)', 'Word (.docx)', 'Markdown (.md)', 'API Push (Slack, CRM, Notion)'].map((format) => (
            <label key={format} className="flex items-center gap-1 cursor-pointer">
              <input
                type="radio"
                name="format"
                value={format}
                checked={selectedExportFormats === format}
                onChange={() => setSelectedExportFormats(format)}
                className="accent-primary-900"
              />
              <span className="text-sm">{format}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="mb-3">
        <label className="block font-semibold mb-1">Appendix Controls</label>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
          {['Source Ledger', 'Validation Chain Graphs', 'Statistical Parameter Tables', 'Glossary of Metrics', 'Model Documentation'].map((callout) => (
            <label key={callout} className="flex items-center gap-1 cursor-pointer">
              <input
                type="checkbox"
                name="callout"
                value={callout}
                checked={selectedCallouts.includes(callout)}
                onChange={() => setSelectedCallouts(selectedCallouts.includes(callout) ? selectedCallouts.filter((c) => c !== callout) : [...selectedCallouts, callout])}
                className="accent-primary-900"
              />
              <span className="text-sm">{callout}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="mb-3">
        <label className="block font-semibold mb-1">Download Modes</label>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-1 items-start">
          {['Audit Mode \n Full detail, confidence intervals, sources, glossary', 'Boardroom Mode \n Executive summary + visuals only', 'Client Clean Mode \n White-labeled, hides methodology', 'Technical Mode \n Tables, parameters, charts with AUC/CI, formulas'].map((mode) => (
            <label key={mode} className="flex items-center gap-1 cursor-pointer">
              <input
                type="radio"
                name="mode"
                value={mode}
                checked={selectedDownloadModes === mode}
                onChange={() => setSelectedDownloadModes(mode)}
                className="accent-primary-900"
              />
              <span className="text-sm">{mode}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="mb-3">
        <label className="block font-semibold mb-1">Tone Application Level</label>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
          {['Entire Report', 'Specific Sections', 'Individual Paragraphs'].map((level) => (
            <label key={level} className="flex items-center gap-1 cursor-pointer">
              <input
                type="radio"
                name="level"
                value={level}
                checked={selectedToneApplicationLevel === level}
                onChange={() => setSelectedToneApplicationLevel(level)}
                className="accent-primary-900"
              />
              <span className="text-sm">{level}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="mb-3">
        <label className="block font-semibold mb-1">White-Label Settings</label>
        <div className="flex flex-wrap gap-1 md:gap-3 lg:gap-4">
          {['Hide all Generated by Perceive Now', 'Replace with partner or client branding', 'Remove watermark'].map((whiteLabel) => (
            <label key={whiteLabel} className="flex items-center gap-1 cursor-pointer">
              <input
                type="checkbox"
                name="callout"
                value={whiteLabel}
                checked={selectedWhiteLabelSettings.includes(whiteLabel)}
                onChange={() => setSelectedWhiteLabelSettings(selectedWhiteLabelSettings.includes(whiteLabel) ? selectedWhiteLabelSettings.filter((c) => c !== whiteLabel) : [...selectedWhiteLabelSettings, whiteLabel])}
                className="accent-primary-900"
              />
              <span className="text-sm">{whiteLabel}</span>
            </label>
          ))}
        </div>
      </div>

    </ContentCard>
  );
};

// --- Reusable UI Components ---
const NavItem: FC<NavItemProps> = ({ number, label, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`flex items-center w-full text-left px-1 py-1 rounded-lg transition-all duration-200 ease-in-out mb-1 ${isActive
      ? "bg-primary-900 text-white shadow-lg"
      : " text-secondary-800 hover:bg-white hover:shadow-sm"
      }`}
  >
    <span
      className={`flex items-center justify-center w-4 h-4 rounded-md mr-1 font-semibold text-sm border border-[#E8EAF2] ${isActive ? "bg-white text-primary-900" : " text-secondary-800"
        }`}
    >
      {number}
    </span>
    <span className="font-normal text-base">{label}</span>
  </button>
);

const ContentCard: FC<ContentCardProps> = ({ title, children }) => (
  <div className="bg-white">
    <h2 className="text-2xl font-bold text-secondary-800">{title}</h2>
    {children}
  </div>
);

const InteractiveReport: React.FC = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();

  const state = location.state;

  const agent = state?.agent || "customer-360-agent";

  const agentNameMapping: Record<string, string> = {
    "customer-360-agent": "Customer 360",
    "investment-diligence-agent": "Investment Diligence",
    "marketing-agent": "Marketing Agent",
    "mr-insights-agent": "MR Insights Agent",
    "report-anything-agent": "Report Anything Agent",
    "": "Customer 360",
  }

  const [summaryData, setSummaryData] = useState<SummaryType[]>([]);
  const [visualsMap, setVisualsMap] = useState<Record<string, VisualType[]>>({});
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("explore");

  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(true);

  const [status, setStatus] = useState("");
  const [pageType, setPageType] = useState<"front" | "report">("front"); // front | report
  const [downloadPreviewPage, setDownlaodPreviewPage] = useState<{ page: "front" | "report", type: "full" | "summary" }>({
    page: "front",
    type: "full"
  }); // front | report
  const userId = jsCookie.get("user_id");
  const [searchParams] = useSearchParams();
  const threadId = `${searchParams.get("threadId")}`

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const retryRef = useRef<NodeJS.Timeout | null>(null);
  const statusRetryRef = useRef<NodeJS.Timeout | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const isMountedRef = useRef(true);

  let retryCount = 0;
  let pipelineRetryCount = 0;

  const MAX_RETRIES = Infinity;
  const MAX_PIPELINE_RETRIES = Infinity;

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
      if (retryRef.current) clearTimeout(retryRef.current);
      if (statusRetryRef.current) clearTimeout(statusRetryRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const postInteractiveInput = async () => {
    if (!isMountedRef.current) return;

    setLoading(true);
    try {
      const insightsResp = await dispatch(
        getSourceInsights({ userId: userId || "", threadId })
      ).unwrap();

      if (!isMountedRef.current) return;

      setInsights(insightsResp.data);
      setLoading(false);
      retryCount = 0;
    } catch (error) {
      console.error("Error fetching insights:", error);
      if (retryCount < MAX_RETRIES && isMountedRef.current) {
        retryCount++;
        retryRef.current = setTimeout(postInteractiveInput, 20000);
      } else {
        setLoading(false);
      }
    }
  };

  const getStatusofPipeline = async () => {
    if (!isMountedRef.current) return;

    try {
      const response = await dispatch(
        getPipelineStatus({ userId: userId || "", threadId })
      ).unwrap();

      if (!isMountedRef.current) return;

      setStatus(response.data.status);
      pipelineRetryCount = 0;
    } catch (error) {
      console.error("Error fetching pipeline status:", error);
      if (pipelineRetryCount < MAX_PIPELINE_RETRIES && isMountedRef.current) {
        pipelineRetryCount++;
        statusRetryRef.current = setTimeout(getStatusofPipeline, 20000);
      }
    }
  };

  const [fetchingTitle, setFetchingTitle] = useState(true);
  const [reportTitle, setReportTitle] = useState<Record<string, string>>({});

  const getReportInfo = async () => {

    setFetchingTitle(true);
    try {
      const response = await dispatch(
        getReportTitle({ userId: userId || "", threadId })
      ).unwrap();

      setReportTitle({
        title: response.data.title || "One View. Every Customer. Total clarity.",
        desc: response.data.subtitle || "The Invisible Hand of the High-Value Shopper"
      });
      setFetchingTitle(false);

    } catch (error) {
      console.error("Error fetching report title:", error);
      setFetchingTitle(false);
      setReportTitle({
        title: agent === "report-anything-agent" ? "Report Anything™ - Executive Edition" : "One View. Every Customer. Total clarity.",
        desc: agent === "report-anything-agent" ? "" : "The Invisible Hand of the High-Value Shopper"
      });
    }
  };

  useEffect(() => {
    getReportInfo();
  }, [threadId]);

  const getInteractiveReport = async () => {
    if (!isMountedRef.current) return;

    setTimeout(async () => {
      if (!isMountedRef.current) return;

      try {
        const [summaryResp, mapResp] = await dispatch(
          getInteractiveReportAction({ userId: userId || "", threadId })
        ).unwrap();

        const visualsMap: any = {};

        mapResp?.data?.forEach((item: any) => {
          const key = `${item.section.trim()} > ${item.subsection.trim()}`;
          if (!visualsMap[key]) visualsMap[key] = [];
          visualsMap[key].push(item);
        });

        if (!isMountedRef.current) return;

        setVisualsMap(visualsMap);
        setSummaryData(summaryResp.data as SummaryType[]);
      } catch (e) {
        console.error("Error fetching report:", e);
      }
    }, 10000);
  };

  useEffect(() => {
    postInteractiveInput();
    getStatusofPipeline();
  }, []);

  useEffect(() => {
    if (status !== "completed") {
      intervalRef.current = setInterval(() => {
        getStatusofPipeline();
      }, 20000);
    } else {
      clearInterval(intervalRef.current!);
      getInteractiveReport();
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [status]);

  const navItems = [
    { id: "explore", label: "Explore Report", number: 1 },
    // { id: "audit", label: "Audit Parameters", number: 2 },
    // { id: "layout", label: "Customize Layout", number: 3 },
    // { id: "tone", label: "Customize Tone", number: 4 },
    { id: "download", label: "Download Options", number: 2 },
  ];

  const groupBySection = (data: any[]) => {
    return data.reduce((acc, item) => {
      if (!acc[item.section]) {
        acc[item.section] = [];
      }
      acc[item.section].push(item);
      return acc;
    }, {} as Record<string, any[]>);
  };

  const renderFullReport = () => {
    const groupedSummaryData = groupBySection(summaryData);

    return loading ? (
      <div className="flex items-center justify-center p-5 h-full w-full section-block pt-2 min-h-[50vh]">
        <DotLoader />
      </div>
    ) : status !== "completed" ? (
      <QuerySlideshow data={insights} interval={15000} />
    ) : (
      Object.entries(groupedSummaryData).map(([sectionName, subsections]: any, idx) => {
        const isOpen = openIndex === idx;
        const anchor = sectionName.replace(/\s+/g, "-");

        return (
          <div
            key={idx}
            className="section-block pt-2"
            id={anchor}
            style={styles.sectionBlock}
          >
            {/* Section Accordion */}
            <button
              onClick={() => toggleAccordion(idx)}
              className={`w-full text-left rounded-lg font-bold text-lg px-1 py-1 flex justify-between items-center hover:bg-[#FFF6E6] border hover:border-[#FFA300] transition ${isOpen ? "bg-[#FFF6E6] border-[#FFA300]" : "bg-[#F5F7FF] border-[#F0F0F0]"
                }`}
            >
              <span>{idx + 1}. {sectionName}</span>
              {isOpen ? (
                <ChevronUp size={20} className="p-[5px] w-4 h-4 rounded-lg inline-flex bg-primary-900 text-white justify-center items-center" />
              ) : (
                <ChevronDown size={20} className="w-4 h-4 rounded-lg inline-flex bg-primary-900 text-white justify-center items-center p-[5px]" />
              )}
            </button>

            {/* Subsections inside accordion */}
            {(isOpen) && (
              <div className="px-4 pb-4 pt-2 bg-white text-sm text-secondary-800 space-y-6">
                {subsections.map((s: any, subIdx: number) => {
                  const visuals = visualsMap[`${s.section} > ${s.subsection}`] || [];
                  const usedSources = s.retrieved_sources?.filter((src: any) => src.used) || [];
                  const unusedSources = s.retrieved_sources?.filter((src: any) => !src.used) || [];

                  return (
                    <div key={subIdx}>
                      <h3 className="font-semibold text-base mb-2">
                        {idx + 1}.{subIdx + 1} {s.subsection}
                      </h3>

                      <div className="summary-text" style={styles.summaryText}>
                        <Markdown
                          className="markdownWrapper text-secondary-800 text-align relative"
                          remarkPlugins={[remarkGfm]}
                          rehypePlugins={[
                            [rehypeExternalLinks, { target: "_blank", rel: "noopener noreferrer" }],
                          ]}
                        >
                          {s.summary}
                        </Markdown>
                      </div>

                      {/* visuals */}
                      {visuals.map((vis: any, i: number) => (
                        <div className="visual-wrapper" key={i} style={styles.visualWrapper}>
                          {vis.bytes || vis.file ? (
                            <img
                              src={vis?.bytes ? `data:image/png;base64,${vis.bytes}` : vis.file}
                              alt={`Visual for ${s.section}-${s.subsection}`}
                              style={styles.visualImage}
                            />
                          ) : null}
                          {vis.svg_content ? (
                            <div
                              className="flex justify-center items-center w-full h-full"
                              dangerouslySetInnerHTML={{
                                __html: vis.svg_content.replace(
                                  /fill\s*=\s*"(#1ac6ff33|#33de7b1a|#ff00001a)"/gi,
                                  'fill="transparent"'
                                ),
                              }}
                            />
                          ) : null}
                        </div>
                      ))}

                      {/* sources */}
                      {(usedSources.length > 0 || unusedSources.length > 0) && (
                        <div className="sources-list" style={styles.sourcesList}>
                          <UsedSourcesAccordion sources={usedSources} />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })
    );
  };


  const renderContent = () => {
    switch (activeTab) {
      case "explore":
        return (
          <>
            {pageType === "front" ? (
              <ExploreReportContent title={reportTitle.title || ""} desc={reportTitle.desc || ""} fetchingTitle={fetchingTitle} agent={agent} />
            ) :
              <>
                {renderFullReport()}
              </>
            }
          </>
        );
      case "audit":
        return <AuditParametersContent />;
      case "layout":
        return <CustomizeLayoutContent />;
      case "tone":
        return <CustomizeToneContent />;
      case "download":
        return downloadPreviewPage.page === "report" ? downloadPreviewPage.type === "full" ? renderFullReport() : <ExecutiveSummary /> : <DownloadOptionsContent updatePreviewPage={({ page, type }: any) => setDownlaodPreviewPage({
          page,
          type
        })} />;
      default:
        return <ExploreReportContent title={reportTitle.title || ""} desc={reportTitle.desc || ""} fetchingTitle={fetchingTitle} agent={agent} />;
    }
  };

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [editorValue, setEditorValue] = useState(`
    <h2>1. Executive Recap</h2>
    <h3>1.1 What's This Report Solving For?</h3>
    <p>
      This Customer 360 report was initiated to answer some of the most critical strategic questions for your business:
      How do we retain our best users? What drives conversion across segments? Which campaigns are underperforming, and why?
      By aggregating, cleaning, and modeling data from CRM systems, loyalty records, campaign platforms, and web activity,
      we're delivering a unified intelligence layer across your customer base.
      The output is not just metrics, it's direction. Actionable insights that help you fine-tune personalization,
      mitigate churn, and unlock lifetime value.
    </p>
  `);

  const quillModules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link', 'image'],
      ['clean']
    ]
  };

  const quillFormats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'link', 'image'
  ];
  const [selectedTone, setSelectedTone] = useState('Executive');
  const [selectedFormat, setSelectedFormat] = useState('Paragraph');
  const [selectedToggles, setSelectedToggles] = useState<string[]>([]);




  return (
    <div style={styles.body} className="h-full w-full">
      <div style={styles.container}>
        <div className="flex justify-between items-center mb-2">
          <div className="inline-flex gap-1 items-center">
            <img src={customerIcon} alt="" />
            <span>{agentNameMapping[agent]}</span>
          </div>
          <div>
            <div className="w-4 h-4 inline-flex justify-center items-center rounded-full bg-primary-900 text-white cursor-pointer">
              <img src={userIcon} alt="" />
            </div>
          </div>
        </div>
        <div style={styles.frontPage}>
          <div style={styles.frontPageContent} className="relative overflow-hidden">
            <img
              src={startupDilligenceImage}
              alt=""
              className="absolute object-cover top-0 left-0 bottom-0 right-0 w-full h-full"
            />
            <h1 className="relative bg-white text-lg p-1 rounded font-semibold">
              Your {agentNameMapping[agent]} Report is Ready. Every Insight is Traceable. Every Decision is
              Defensible
            </h1>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-5 relative  items-start min-w-[100%]">
          <div className="md:sticky top-1" style={styles.toc}>
            <nav>
              {navItems.map((item) => (
                <NavItem
                  key={item.id}
                  number={item.number}
                  label={item.label}
                  isActive={activeTab === item.id}
                  onClick={() => setActiveTab(item.id)}
                />
              ))}
            </nav>
          </div>

          <div className="md:col-span-3 flex flex-col scroll-smooth border border-[#D7D7D7] rounded-xl p-3">
            <div
              className="border-b border-[#D7D7D7] mb-2 pb-2 flex justify-between flex-col md:flex-row gap-2 md:items-center"
              id="customer-360"
            >
              <div>
                <div className="text-lg font-semibold">{agentNameMapping[agent]} Intelligence Report</div>
                <div className="text-base font-normal">Customize sections to suit your needs.</div>
              </div>
              {activeTab === "explore" && (
                <div>
                  <button
                    className="w-full cursor-pointer  rounded-full px-5 py-1 border border-secondary-500 hover:bg-foundationOrange-100 text-[#373D3F] flex justify-between gap-2 items-center"
                    // className=" border border-[#FFA300] bg-[#FFF7ED] px-5 py-1 text-[#373D3F] rounded-full"
                    onClick={() => setPageType(pageType === "front" ? "report" : "front")}
                  >
                    {pageType === "front" ? "Next" : "Back"}
                  </button>
                </div>
              )}
              {activeTab === "download" && downloadPreviewPage.page === "report" && (
                <div>
                  <button
                    className="w-full cursor-pointer  rounded-full px-5 py-1 border border-secondary-500 hover:bg-foundationOrange-100 text-[#373D3F] flex justify-between gap-2 items-center"
                    // className=" border border-[#FFA300] bg-[#FFF7ED] px-5 py-1 text-[#373D3F] rounded-full"
                    onClick={() => {
                      setDownlaodPreviewPage({
                        page: downloadPreviewPage.page === "front" ? "report" : "front",
                        type: downloadPreviewPage.type
                      });
                    }}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
            <div className="flex-0">
              {error && <p style={{ color: "red" }}>❌ Failed to load report data: {error}</p>}
            </div>
            {activeTab === "explore" && (
              <>
                <div className="flex items-center p-2 space-x-2 bg-white rounded-2xl shadow-sm border border-gray-200 justify-end mb-3">
                  {status !== "completed" ? (
                    <>
                      <div className="flex justfy-between items-center w-full gap-2">
                        <Loader2 className="w-5 h-5 animate-spin text-yellow-300" />
                        <p className="">We are still generating the report...</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex justfy-between items-center w-full gap-2">
                        {activeTab === "explore" && (
                          <>
                            <CheckCircle className="w-5 h-5 text-green-400" />
                            <p className="text-green-300 font-semibold">Report generated!</p>
                          </>
                        )}
                      </div>
                    </>
                  )}

                  {icons.map(({ name, Component }) => (
                    <ToolTip key={name} title={name} placement="bottom">
                      <IconButton
                        Icon={Component}
                        label={name}
                        onClick={() => {
                          if (name === "Download") {
                            downloadReportPdf(summaryData, visualsMap, reportTitle.title || "", reportTitle.desc || "", agent);
                            return
                          }
                          if (name === "Download Doc") {
                            downloadReportDocx(summaryData, visualsMap, reportTitle.title || "", reportTitle.desc || "", agent);
                            return
                          }
                          if (name === "Edit") setEditModalOpen(true);
                          if (name === "History") setHistoryModalOpen(true);
                          if (name === "Regenerate Report") {
                            dispatch(executePipelineAction({
                              userId: userId || "",
                              threadId: threadId || ""
                            })).unwrap();
                          }
                        }}
                      />
                    </ToolTip>
                  ))}
                </div>
                {status !== "completed" ? (
                  <div className="flex justfy-between items-center w-full gap-2 my-3 mb-1">
                    {/* <h2 className="font-bold text-lg">
                      Below data is generating through sources...
                    </h2>
                    */}
                  </div>
                ) : null}
              </>
            )}
            <div className="overflow-y-auto flex-auto">{renderContent()}</div>
          </div>
        </div>
      </div>
      <Modal open={editModalOpen} handleOnClose={() => setEditModalOpen(false)}>
        <div className="p-6 bg-white rounded-lg max-w-[1300px] mx-auto relative">
          <X className="z-10 cursor-pointer absolute top-[30px] right-[30px]" onClick={() => setEditModalOpen(false)} />
          <h2 className="text-2xl font-bold mb-2 text-left">Edit Paragraph</h2>
          <ReactQuill
            value={editorValue}
            onChange={setEditorValue}
            modules={quillModules}
            formats={quillFormats}
            className="text-left"
          />
          <button className="mt-2 px-3 py-[12px] bg-primary-900 text-white rounded-xl ml-auto mr-0 block" onClick={() => setEditModalOpen(false)}>Submit</button>
        </div>
      </Modal>
      <Modal open={historyModalOpen} handleOnClose={() => setHistoryModalOpen(false)}>
        <div className="p-6 bg-white rounded-lg max-w-2xl mx-auto text-left relative">
          <X className="z-10 cursor-pointer absolute top-[30px] right-[30px]" onClick={() => setHistoryModalOpen(false)} />
          <h2 className="text-2xl font-bold mb-2 text-left">Regenerate</h2>
          <div className="mb-3">
            <label className="block font-semibold mb-1">Select tone</label>
            <div className="flex flex-wrap gap-2">
              {['Executive', 'Analytical', 'Conversational', 'Persuasive', 'Investor-Focused'].map((tone) => (
                <label key={tone} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="tone"
                    value={tone}
                    checked={selectedTone === tone}
                    onChange={() => setSelectedTone(tone)}
                    className="accent-primary-900"
                  />
                  <span>{tone}</span>
                </label>
              ))}
            </div>
          </div>
          <div className="mb-3">
            <label className="block font-semibold mb-1">Choose format</label>
            <div className="flex flex-wrap gap-2">
              {['Paragraph', 'Bulleted', 'Summary'].map((format) => (
                <label key={format} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="format"
                    value={format}
                    checked={selectedFormat === format}
                    onChange={() => setSelectedFormat(format)}
                    className="accent-primary-900"
                  />
                  <span>{format}</span>
                </label>
              ))}
            </div>
          </div>
          <div className="mb-2">
            <label className="block font-semibold mb-1">Optional toggles</label>
            <div className="flex flex-col gap-2">
              {['Include Source Footnotes', 'Show Confidence Score Inline', 'Highlight Input Variables'].map((toggle) => (
                <label key={toggle} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    name="toggle"
                    value={toggle}
                    checked={selectedToggles.includes(toggle)}
                    onChange={() => {
                      setSelectedToggles((prev) =>
                        prev.includes(toggle)
                          ? prev.filter((t) => t !== toggle)
                          : [...prev, toggle]
                      );
                    }}
                    className="accent-primary-900"
                  />
                  <span>{toggle}</span>
                </label>
              ))}
            </div>
          </div>
          <button className="mt-2 px-3 py-[12px] bg-primary-900 text-white rounded-xl ml-auto mr-0 block" onClick={() => setHistoryModalOpen(false)}>Submit</button>
        </div>
      </Modal>
    </div>
  );
};

export default InteractiveReport;

const styles: { [key: string]: React.CSSProperties } = {
  body: {
    fontFamily: `'Inter', sans-serif`,
    backgroundColor: "#f9f9fc",
    color: "#2b2b2b",
    margin: 0,
    padding: "0",
  },
  h2: {
    color: "#442873FF",
    fontSize: "20px",
    fontWeight: 600,
    // padding: "10px 0"
  },
  container: {
    maxWidth: "100%",
    margin: "auto",
    background: "#fff",
    padding: "1rem 0",
    borderRadius: 0,
    boxShadow: "none",
  },
  frontPage: {
    paddingBottom: "1rem",
  },
  frontPageContent: {
    height: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    background: "linear-gradient(to bottom right, #f8f9fa, #e9ecef)",
    borderRadius: 12,
    padding: "2rem",
  },
  toc: {
    background: "#FFF7ED",
    padding: "1rem",
    borderRadius: 10,
    marginBottom: "2rem",
  },
  tocList: {
    listStyle: "decimal-leading-zero",
    paddingLeft: "2rem",
    textAlign: "left",
  },
  tocItem: {
    marginBottom: "0.5rem",
  },
  tocLink: {
    textDecoration: "none",
    color: "#373D3F",
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  sectionBlock: {},
  summaryText: {
    marginTop: "0.5rem",
    lineHeight: 1.6,
  },
  sourcesList: {
    marginTop: "1rem",
  },
  visualWrapper: {
    marginTop: "1rem",
    textAlign: "center",
  },
  visualImage: {
    // maxWidth: "50%",
    marginLeft: 'auto',
    marginRight: 'auto',
    border: "1px solid #ccc",
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  downloadBtn: {
    display: "block",
    margin: "2rem auto 0",
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
    backgroundColor: "#1a73e8",
    color: "white",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
  },
};
